import type { CSSProperties, MouseEvent } from "react";
import { useAppContext } from "../contexts/AppContext";
import Frame from "./Frame";
import Search from "./Search";
import sodoStyles from "../sodo";

const MODAL_CONTAINER_STYLE: CSSProperties = {
  zIndex: "3999999",
  position: "fixed",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  overflow: "hidden",
};

const FRAME_STYLE: CSSProperties = {
  margin: "auto",
  position: "relative",
  padding: "0",
  outline: "0",
  width: "100%",
  opacity: "1",
  overflow: "hidden",
  height: "100%",
};

export default function PopupModal() {
  const { showPopup, dispatch, brandColor } = useAppContext();

  if (!showPopup) {
    return null;
  }

  const styles = `
    :root { --brandcolor: ${brandColor ?? ""} }
    .ghost-display { display: none; }
  `;

  const head = (
    <>
      <style dangerouslySetInnerHTML={{ __html: sodoStyles }} />
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
    </>
  );

  const handleBackdropClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.target === e.currentTarget) {
      dispatch("update", { showPopup: false });
    }
  };

  return (
    <div style={MODAL_CONTAINER_STYLE} className="gh-root-frame">
      <Frame style={FRAME_STYLE} title="portal-popup" head={head}>
        <div
          onClick={handleBackdropClick}
          className="absolute top-0 bottom-0 left-0 right-0 block backdrop-blur-[2px] animate-fadein z-0 bg-gradient-to-br from-[rgba(0,0,0,0.2)] to-[rgba(0,0,0,0.1)]"
        />
        <Search />
      </Frame>
    </div>
  );
}
